// Real-user Core Web Vitals -> dataLayer -> GTM -> GA4.
// Requires web-vitals.iife.js to load first (both deferred, order preserved).
// GTM: custom-event trigger "web_vitals" + GA4 event tag (measurement ID
// override), params mapped from the fields pushed below.
(function () {
  if (!window.webVitals) return;

  function send(metric) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'web_vitals',
      metric_name: metric.name,
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating,
      metric_navigation_type: metric.navigationType,
    });
  }

  window.webVitals.onLCP(send);
  window.webVitals.onCLS(send);
  window.webVitals.onINP(send);
  window.webVitals.onTTFB(send);
})();
